import * as React from 'react';
import {EmailChangedModalDispatchProps, MediciValidationsModalDispatchProps} from '../../types/containers';

class EmailChangedModalView
    extends React.Component<EmailChangedModalDispatchProps, {}> {

    renderDetail() {
        return <React.Fragment>
            <p>
                El correo del cliente ha sido modificado. No olvides, enviarle el correo de validación de identidad al nuevo correo.
            </p>
        </React.Fragment>;
    }

    renderButton(onPressClose) {
        return <React.Fragment>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressClose}>Entendido</a></React.Fragment>;
    }

    render() {
        const {onPressClose} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail()}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressClose)}
                </div>
            </div>
        );
    }
}

export default EmailChangedModalView;
